import { render, staticRenderFns } from "./riskRuleList.vue?vue&type=template&id=c5ffdce4&scoped=true"
import script from "./riskRuleList.vue?vue&type=script&lang=js"
export * from "./riskRuleList.vue?vue&type=script&lang=js"
import style0 from "./riskRuleList.vue?vue&type=style&index=0&id=c5ffdce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ffdce4",
  null
  
)

export default component.exports